<template>
    <el-button text class="button" v-if="tickett.status!='Closed'" @click="action='reply';drawer=true">Reply</el-button>
    <el-button text class="button" v-if="tickett.status!='Closed'" @click="action='close';drawer=true">Close Ticket</el-button>
    <el-button text class="button" v-if="tickett.status=='Closed'" @click="action='reopen';drawer=true">Reopen Ticket</el-button>

    <el-drawer v-model="drawer" direction="rtl" :before-close="handleClose">
        <template #header>
            <h4 v-if="action=='reply'">Reply Ticket</h4>
            <h4 v-else-if="action=='reopen'">Reopen Ticket</h4>
            <h4 v-else>Close Ticket</h4>
        </template>
        <template #default>
            <el-form
                label-position="top"
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
            >
                <el-row>

                    <el-col :span="24">
                        <el-form-item label="Description"  prop="description">

                            <el-input class="mt-2" :rows="10"  type="textarea" v-model="form.description"  placeholder="Enter Description" >

                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="Attachments">

                            <el-upload
                                ref="uploadRef"
                                class="upload-demo"
                                action=""
                                :auto-upload="false"
                                :on-change="fileadded"
                                :on-remove="fileadded"
                            >
                                <template #trigger>
                                    <el-button type="primary">select file</el-button>
                                </template>

                                <template #tip>
                                    <div class="el-upload__tip">
                                        jpg/png/pdf/doc/xlsx files
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>


                </el-row>



            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">

                <el-button v-if="action=='reply'" type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Reply</el-button>
                <el-button v-else-if="action=='reopen'" type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Reopen</el-button>
                <el-button v-else type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Close</el-button>



            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElInput,
    ElSelect,
    ElOption,
    ElFormItem,
    ElForm,
    ElCol,
    ElRow,
    ElButton,
    ElCard,
    ElDivider,
    ElDrawer,
    ElDatePicker, ElTag, ElAvatar, ElSkeleton,ElUpload,ElMessage
} from 'element-plus'
import 'element-plus/dist/index.css'
export default {
    name: "NewTicket",
    components: { ElInput,ElUpload,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElDrawer,ElSkeleton },
    props:{
        ticket: {
            type: Object,
            default () {
                return null
            }
        },
    },
    data() {
        return {
            tickett:'',
            action:'',
            drawer: false,
            loading:false,
            form: {
                ticketid:'',
                description:'',
                files:[]
            },
            rules:{
                description: [{ required: true, trigger: 'change', message:'' }],
            }
        }
    },
    created()
    {

            this.form.ticketid = this.ticket.id;
            this.tickett=this.ticket

    },
    methods: {
        handleClose() {
            this.drawer=false

        },
        submitForm(){
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                    this.form.files.map(function(file, key) {
                        formData.append('attachments[]', file);
                    });

                    formData.append('description', this.form.description);
                    formData.append('ticketid', this.form.ticketid);

                    if(this.action=='reply'){
                        axios.post('/tickets/addreply',formData, config).then(function (response) {

                            currentObj.loading=false;
                            ElMessage({
                                showClose: true,
                                message: 'Ticket Replied Succesfully.',
                                type: 'success',
                            });
                            formEl.resetFields();
                            currentObj.form.files=[];
                            currentObj.$refs.uploadRef.clearFiles();
                            currentObj.drawer=false;
                            currentObj.$emit('saved');

                        })
                            .catch(function (error) {
                                currentObj.loading=false;
                            });
                    }
                    else if(this.action=='reopen'){
                        axios.post('/tickets/reopen',formData, config).then(function (response) {

                            currentObj.loading=false;
                            ElMessage({
                                showClose: true,
                                message: 'Ticket Reopen Succesfully.',
                                type: 'success',
                            });
                            formEl.resetFields();
                            currentObj.form.files=[];
                            currentObj.$refs.uploadRef.clearFiles();
                            currentObj.drawer=false;
                            currentObj.$emit('saved');

                        })
                            .catch(function (error) {
                                currentObj.loading=false;
                            });
                    }
                    else{
                        axios.post('/tickets/close',formData, config).then(function (response) {

                            currentObj.loading=false;
                            ElMessage({
                                showClose: true,
                                message: 'Ticket Closed Succesfully.',
                                type: 'success',
                            });
                            formEl.resetFields();
                            currentObj.form.files=[];
                            currentObj.$refs.uploadRef.clearFiles();
                            currentObj.drawer=false;
                            currentObj.$emit('saved');

                        })
                            .catch(function (error) {
                                currentObj.loading=false;
                            });
                    }

                } else {

                    return false
                }
            })
        },
        fileadded(uploadFile, uploadFiles){
            this.form.files=[];

            let currentObj = this;
            uploadFiles.map(function(value, key) {
                currentObj.form.files.push(value.raw);
            });
        }
    }
}
</script>

<style scoped>

</style>
